import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Input,
  Text,
  Button,
  Flex,
  useToast,
  Spinner,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  IconButton,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
} from "@chakra-ui/react";
import "react-quill/dist/quill.snow.css";
import axios from "axios";
import Navbar from "../Navbar/Navbar";
import Sidebar from "../Sidebar";
import * as mod from "../../url";
import { Link as RouterLink } from "react-router-dom";
import { Link as ChakraLink } from "@chakra-ui/react";
import { AddIcon, DeleteIcon, EditIcon } from "@chakra-ui/icons";
const storedData = JSON.parse(sessionStorage.getItem("superAdminLawvs"));
const token = storedData?.data?.token;
const SIDEBAR_WIDTH = "250px";

export const CreateQueCategory = () => {
  const [category, setCategory] = useState("");
  const [allCategory, setAllCategory] = useState("");
  const config = { headers: { Authorization: `${token}` } };
  const [loading, setLoading] = useState(true);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [catName, setCatName] = useState("");
  const [selectedCat, setSelectedCat] = useState(null);
  const [updating, setUpdating] = useState(false);
  const toast = useToast();
  const editorRef = useRef(null);

  const handleEditClick = (category) => {
    setSelectedCat(category);
    setCatName(category.name); // yahan category name set hoga input ke liye
    onOpen();
  };

  const getAllCategory = async () => {
    try {
      const { data } = await axios.get(
        `${mod.api_url}/api/v1/category/get_all_category`
      );
      setAllCategory(data);
      setLoading(false);
    } catch (error) {
      // console.error("error getting data", error.response);
      setLoading(false);
      toast({
        category: "getting failed.",
        description: "Something went wrong while getting the category.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleUpdate = async () => {
    if (!selectedCat) return;
    setUpdating(true);
    try {
      await axios.put(
        `${mod.api_url}/api/v1/category/update_category/${selectedCat._id}`,
        { name: catName }
      );
      toast({
        title: "Category updated.",
        description: "Your category updated successfully.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      onClose();
      getAllCategory();
    } catch (error) {
      // console.error(error);
      toast({
        title: "Error updating category.",
        description: error.response?.data?.message || "Something went wrong.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setUpdating(false);
    }
  };

  const handleSubmit = async () => {
    try {
      const res = await axios.post(
        `${mod.api_url}/api/v1/category/create_que_category`,
        {
          name: category,
        },
        config
      );
      toast({
        category: "category submitted.",
        description: "Your category was successfully posted.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      setCategory("");
      getAllCategory();
    } catch (error) {
      // console.error("Error submitting category:", error.response?.data);

      toast({
        category: "Submission failed.",
        description:
          error.response?.data?.message ||
          "Something went wrong while posting the category.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    getAllCategory();
  }, []);
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this category?"
    );
    if (!confirmDelete) return;

    try {
      await axios.delete(
        `${mod.api_url}/api/v1/category/delete_cat/${id}`,
        config
      );

      toast({
        title: "Draft deleted successfully.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      getAllCategory();
    } catch (error) {
      // console.error("Delete error:", error);
      toast({
        title: "Failed to delete category.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };
  return (
    <>
      <Navbar />
      <Sidebar />
      <Box mt="100px" ml={{ base: 0, md: SIDEBAR_WIDTH }} p={2}>
        <Box
          maxW="1000px"
          mx="auto"
          bg="white"
          p={6}
          borderRadius="md"
          boxShadow="md"
        >
          <Text fontSize="2xl" mb={4} bg="#D29B3F" p={3}>
            Add Question Category
          </Text>
          <Input
            placeholder="Enter Title"
            mb={6}
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          />

          <Flex justify="flex-end" mt={4} gap={4}>
            <Button
              variant="ghost"
              onClick={() => {
                setCategory("");
              }}
            >
              Cancel
            </Button>
            <Button colorScheme="green" onClick={handleSubmit}>
              Submit
            </Button>
          </Flex>
        </Box>
        <Box
          maxW="1000px"
          mx="auto"
          bg="white"
          p={6}
          borderRadius="md"
          boxShadow="md"
        >
          <Text fontSize="sm" mb={1} textAlign={"right"} align={"right"}>
            Total Record: {allCategory?.length}
          </Text>
          {loading ? (
            <Spinner size="xl" />
          ) : (
            <>
              <Table
                variant="simple"
                size="sm"
                style={{ border: "1px solid #ccc", borderCollapse: "collapse" }}
              >
                <Thead bg="gray.100">
                  <Tr>
                    <Th border="1px solid #ccc">ID</Th>
                    <Th border="1px solid #ccc">Title</Th>
                    <Th border="1px solid #ccc">Date</Th>
                    <Th border="1px solid #ccc">Action</Th>
                    <Th border="1px solid #ccc">Delete</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {allCategory?.map((cat, index) => (
                    <Tr key={cat?._id}>
                      <Td border="1px solid #ccc">{index + 1}</Td>
                      <Td border="1px solid #ccc">
                        <ChakraLink
                          as={RouterLink}
                          to={`/single-cat/${cat?.slug}`} // navigate to single cat page
                          color="blue.500"
                          _hover={{ textDecoration: "underline" }}
                        >
                          {cat?.name}
                        </ChakraLink>
                      </Td>

                      <Td border="1px solid #ccc">
                        {new Date(cat.createdAt).toLocaleDateString()}
                      </Td>
                      <Td border="1px solid #ccc">
                        <IconButton
                          icon={<EditIcon />}
                          colorScheme="blue"
                          size="sm"
                          aria-label="Edit"
                          onClick={() => handleEditClick(cat)}
                          padding={5}
                        />
                      </Td>

                      {/* Modal */}
                      <Modal isOpen={isOpen} onClose={onClose}>
                        <ModalOverlay />
                        <ModalContent>
                          <ModalHeader>Update Category</ModalHeader>
                          <ModalCloseButton />
                          <ModalBody>
                            <Input
                              value={catName}
                              onChange={(e) => setCatName(e.target.value)}
                              placeholder="Enter category name"
                            />
                          </ModalBody>

                          <ModalFooter>
                            <Button
                              colorScheme="blue"
                              mr={1}
                              onClick={handleUpdate}
                            >
                              Update
                            </Button>
                            <Button variant="ghost" onClick={onClose}>
                              Cancel
                            </Button>
                          </ModalFooter>
                        </ModalContent>
                      </Modal>
                      <Td border="1px solid #ccc">
                        <IconButton
                          icon={<DeleteIcon />}
                          colorScheme="red"
                          size="sm"
                          aria-label="Delete"
                          onClick={() => handleDelete(cat._id)}
                          padding={5}
                        />
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </>
          )}
        </Box>
      </Box>
    </>
  );
};
